.slugPreviewGroup {
  margin-top: 2px;
  margin-bottom: 2px;
}

.slugPreviewButton {
  margin-top: -2px;
}
